// 10:26pm
export default {
    "lyrics": [
        {
            "characters": ["vc"],
            "time": "00:01",
            "lyric": "Hell!"
        },
        {
            "characters": ["vc"],
            "time": "00:07",
            "lyric": "We are gonna die"
        }, 
        {
            "characters": ["vc"],
            "time": "00:10",
            "lyric": "We can't survive"
        },
        {
            "characters": ["vc"],
            "time": "00:13",
            "lyric": "Shit's gonna hit the fan"
        },
        {
            "characters": ["vc"],
            "time": "00:17",
            "lyric": "So people run to the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:21",
            "lyric": "We are gonna die"
        },
        {
            "characters": ["vc"],
            "time": "00:23",
            "lyric": "We can't survive"
        },
        {
            "characters": ["vc"],
            "time": "00:24",
            "lyric": "Shit's gonna hit the fan"
        },
        {
            "characters": ["vc"],
            "time": "00:27",
            "lyric": "So people run. Run to the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:28",
            "lyric": "We are gonna die"
        },
        {
            "characters": ["vc"],
            "time": "00:30",
            "lyric": "We can't survive"
        },
        {
            "characters": ["vc"],
            "time": "00:32",
            "lyric": "Shit's gonna hit the fan"
        },
        {
            "characters": ["vc"],
            "time": "00:34",
            "lyric": "So people run. Run to the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:36",
            "lyric": "C'mon everyone. Sing with me"
        },
        {
            "characters": ["vc"],
            "time": "00:38",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc"],
            "time": "00:39",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:41",
            "lyric": "Just pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "00:44",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:45",
            "lyric": "Your funds from the bank (congregation)"
        },
        {
            "characters": ["vc"],
            "time": "00:46",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc"],
            "time": "00:47",
            "lyric": "Pull the livin' shit outta the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:49",
            "lyric": "Just pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "00:51",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:52",
            "lyric": "One more time"
        },
        {
            "characters": ["vc"],
            "time": "00:54",
            "lyric": "Just pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "00:55",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "00:58",
            "lyric": "Let's slow down for a bit"
        },
        {
            "characters": ["vc"],
            "time": "01:00",
            "lyric": "People's lives are filled with problems and doubts"
        },
        {
            "characters": ["vc"],
            "time": "01:02",
            "lyric": "But us. We can only have ups. No downs."
        },
        {
            "characters": ["vc"],
            "time": "01:05",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "01:06",
            "lyric": "What do you mean?"
        },
        {
            "characters": ["startup"],
            "time": "01:10",
            "lyric": "Why y'all pitching a fit?"
        },
        {
            "characters": ["startup"],
            "time": "01:14",
            "lyric": "What does that mean to our green Benjamins?"
        },
        {
            "characters": ["vc"],
            "time": "01:20",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "01:22",
            "lyric": "The valley just said it needs fresh cash"
        },
        {
            "characters": ["vc"],
            "time": "01:30",
            "lyric": "The valley just said it'll be selling shares"
        },
        {
            "characters": ["startup"],
            "time": "01:31",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "01:37",
            "lyric": "Sing with me. They made some bad investments"
        },
        {
            "characters": ["vc", "startup"],
            "time": "01:39",
            "lyric": "The valley just said it needs fresh cash"
        },
        {
            "characters": ["startup"],
            "time": "01:39",
            "lyric": "Fresh cash"
        },
        {
            "characters": ["vc", "startup"],
            "time": "01:47",
            "lyric": "The valley just said it'll be selling shares"
        },
        {
            "characters": ["startup"],
            "time": "01:48",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "01:54",
            "lyric": "Founders, who for so many years lived in awe"
        },
        {
            "characters": ["vc"],
            "time": "01:58",
            "lyric": "Now yelled I can't withdraw"
        },
        {
            "characters": ["vc"],
            "time": "02:10",
            "lyric": "The sunset has just begun"
        },
        {
            "characters": ["vc"],
            "time": "02:13",
            "lyric": "And we were realizing this is a bank run"
        },
        {
            "characters": ["vc"],
            "time": "02:20",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "02:23",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:25",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:26",
            "lyric": "(Just pull it)"
        },
        {
            "characters": ["startup"],
            "time": "02:27",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "02:28",
            "lyric": "Just pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "02:29",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:30",
            "lyric": "Just remove it"
        },
        {
            "characters": ["vc"],
            "time": "02:31",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc"],
            "time": "02:34",
            "lyric": "Pull the livin' shit outta the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:36",
            "lyric": "Just pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "02:37",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:39",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc"],
            "time": "02:41",
            "lyric": "We bring salvation"
        },
        {
            "characters": ["vc"],
            "time": "02:43",
            "lyric": "Just Pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "02:45",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:46",
            "lyric": "(Just remove it)"
        },
        {
            "characters": ["vc"],
            "time": "02:47",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:49",
            "lyric": "Pull the livin' shit outta the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:51",
            "lyric": "Just Pull it. Pull it"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:53",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "02:55",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["startup"],
            "time": "02:56",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "02:58",
            "lyric": "We know the world's truths"
        },
        {
            "characters": ["vc"],
            "time": "03:01",
            "lyric": "Just Pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "03:01",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "03:05",
            "lyric": "Just remove it. Move it"
        },
        {
            "characters": ["vc"],
            "time": "03:06",
            "lyric": "Pull the livin' shit outta the bank"
        },
        {
            "characters": ["vc"],
            "time": "03:07",
            "lyric": "Just Pull it. Pull it"
        },
        {
            "characters": ["vc"],
            "time": "03:09",
            "lyric": "Your funds from the bank"
        },
        {
            "characters": ["vc"],
            "time": "03:11",
            "lyric": "We are gonna die"
        },
        {
            "characters": ["vc"],
            "time": "03:13",
            "lyric": "We can't survive"
        },
        {
            "characters": ["vc"],
            "time": "03:15",
            "lyric": "Shit's gonna hit the fan"
        },
        {
            "characters": ["vc"],
            "time": "03:17",
            "lyric": "People run. Run to the bank"
        },
        {
            "characters": ["vc"],
            "time": "03:19",
            "lyric": "People run (2x)"
        },
        {
            "characters": ["vc"],
            "time": "03:26",
            "lyric": "To the bank"
        },
        {
            "characters": ["vc"],
            "time": "03:29",
            "lyric": "We gotta run"
        },
        {
            "characters": ["vc"],
            "time": "03:31",
            "lyric": "We gonna die. We gonna (multiple times)"
        },
        {
            "characters": ["vc", "startup"],
            "time": "03:38",
            "lyric": "We gonna die. We gonna (multiple times)"
        },
        {
            "characters": ["vc"],
            "time": "03:45",
            "lyric": "So run (multiple times)"
        },
        {
            "characters": ["vc"],
            "time": "03:54",
            "lyric": "We are gonna die. So we run"
        },
        {
            "characters": ["vc"],
            "time": "03:56",
            "lyric": "So run"
        },
        {
            "characters": ["vc"],
            "time": "04:05",
            "lyric": "We are gonna die. So we run!"
        },
    ]
}
